import { Input, Modal } from 'antd';
import { useState } from 'react';

import SaveOutlined from '../../assets/common/SaveOutlined';
import { whitespaceRegex } from '../../Constants/index';
import { getFileNameWithoutExtension } from '../../utils/functions';
import Button from './Button';

const getInitialFormData = (initialText, checkFileNameExtension) => {
  return {
    input: checkFileNameExtension ? getFileNameWithoutExtension(initialText) : initialText,
    error: null,
  };
};

const Content = ({
  onClose,
  initialText,
  loading,
  handleSave,
  submitText,
  cancelText,
  checkFileNameExtension,
  extraValidation,
}) => {
  const [formData, setFormData] = useState(() =>
    getInitialFormData(initialText, checkFileNameExtension)
  );

  function handleChange(e) {
    setFormData((prevData) => ({
      ...prevData,
      input: e.target.value,
      ...(formData.error ? { error: null } : {}),
    }));
  }

  function validate() {
    let isValidate = true;
    if (!formData.input) {
      setFormData((prevData) => ({ ...prevData, error: 'Write Something!' }));
      isValidate = false;
    } else if (whitespaceRegex.test(formData.name)) {
      setFormData((prevData) => ({ ...prevData, error: 'Invalid Input' }));
      isValidate = false;
    }
    return isValidate;
  }

  function onSubmit(e) {
    e.preventDefault();
    if (validate()) {
      const result = initialText?.split('.');
      const length = result?.length;
      const newName = `${formData.input}${length > 1 && checkFileNameExtension ? `.${result[length - 1]}` : ''}`;
      if ((typeof extraValidation === 'function' && extraValidation(newName)) || !extraValidation) {
        handleSave(newName);
      }
    }
  }

  return (
    <form onSubmit={onSubmit} id='form_file_name' style={{ width: '100%' }}>
      <div className='mb-8 fw-500'>Rename</div>
      <Input
        className='text-area'
        value={formData.input}
        onChange={handleChange}
        style={{ borderRadius: '4px' }}
      />
      {formData.error && <div className='color-danger'>{formData.error}</div>}
      <div className='flex mt-24' style={{ gap: '12px' }}>
        <Button
          type='primary'
          className='btn-s'
          onClick={onSubmit}
          loading={loading}
          icon={<SaveOutlined />}
        >
          {submitText}
        </Button>
        <Button type='default' danger className='btn-s' onClick={onClose}>
          {cancelText}
        </Button>
      </div>
    </form>
  );
};

const UpdateFileNameModal = ({
  width = 480,
  isOpen,
  onClose,
  initialText = '',
  loading = false,
  onSave,
  submitText = 'Save',
  cancelText = 'Cancel',
  centered = false,
  checkFileNameExtension = true,
  extraValidation,
}) => {
  return (
    <Modal
      open={isOpen}
      width={width}
      footer={null}
      onCancel={onClose}
      closeIcon={null}
      centered={centered}
      destroyOnHidden
    >
      <Content
        onClose={onClose}
        initialText={initialText}
        loading={loading}
        handleSave={onSave}
        submitText={submitText}
        cancelText={cancelText}
        checkFileNameExtension={checkFileNameExtension}
        extraValidation={extraValidation}
      />
    </Modal>
  );
};

export default UpdateFileNameModal;
